/* The body search is an ordinary form; header predictive search owns its input. */
class MainSearch extends HTMLElement {
  constructor() {
    super();
    const input = this.querySelector('input[type="search"]');
    const reset = this.querySelector('button[type="reset"]');
    if (!input || !reset) return;
    const updateReset = () => reset.classList.toggle('hidden', !input.value);
    input.addEventListener('input', updateReset);
    input.form.addEventListener('reset', (event) => {
      event.preventDefault();
      input.value = '';
      updateReset();
      input.focus();
    });
  }
}

if (!customElements.get('main-search')) customElements.define('main-search', MainSearch);
